import { Injectable } from '@angular/core';
import { NotificationService } from './notification.service';
import { UtilityService } from './utility.service';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Config } from 'config/config';

@Injectable()
export class DataService {

    // private headers: Headers;
    // private _headers: HttpHeaders;

    constructor(
        // private _http: Http,
        private http: HttpClient,
        // private _router: Router,
        // private _authenService: AuthenService,
        private _notificationService: NotificationService,
        private _utilityService: UtilityService) {
        // this.headers = new Headers();
        // this.headers.append('Content-Type', 'application/json');
        // this._headers = new HttpHeaders({ 'Content-Type': 'application/json;charset=utf-8' });
    }
    ///////////////////////////////////////////////
    get(uri: string) {
        // this._headers.delete("Authorization");
        // this._headers.append("Authorization", "Bearer " + localStorage.getItem("scnntttoken"));
        const headers = new HttpHeaders({
            "Content-Type": "application/json;charset=utf-8",
            "Authorization": "Bearer " + localStorage.getItem("scnntttoken")
        });
        return this.http.get<any>(Config.apiUrl + uri, { headers, observe: 'response' }).map(this._extractData);
    }

    post(uri: string, data?: any) {
        const headers = new HttpHeaders({
            "Content-Type": "application/json;charset=utf-8",
            "Authorization": "Bearer " + localStorage.getItem("scnntttoken")
        });
        return this.http.post<any>(Config.apiUrl + uri, JSON.stringify(data), { headers, observe: 'response' }).map(this._extractData);
    }

    delete(uri: string) {
        const headers = new HttpHeaders({
            "Content-Type": "application/json;charset=utf-8",
            "Authorization": "Bearer " + localStorage.getItem("scnntttoken")
        });
        return this.http.delete<any>(Config.apiUrl + uri, { headers, observe: 'response' }).map(this._extractData);
    }

    postFile(uri: string, data?: any) {
        const headers = new HttpHeaders({
            "Authorization": "Bearer " + localStorage.getItem("scnntttoken")
        });
        return this.http.post<any>(Config.apiUrl + uri, data, { headers, observe: 'response' }).map(this._extractData);
    }

    postWithFile(url: string, postData: any, files: File[]) {
        let formData: FormData = new FormData();
        if (files && files.length > 0) {
            for (let i = 0; i < files.length; i++) {
                formData.append('file' + (i + 1), files[i], files[i].name);
            }
        }

        if (postData !== "" && postData !== undefined && postData !== null) {
            for (var property in postData) {
                if (postData.hasOwnProperty(property)) {
                    formData.append(property, postData[property]);
                }
            }
        }
        var returnReponse = new Promise((resolve, reject) => {
            this.postFile(url, formData).subscribe(
                res => {
                    resolve(res);
                },
                error => {
                    // reject(error);
                    this.handleError(error);
                }
            );
        });
        return returnReponse;
    }

    getDownFile(uri: string) {
        const headers = new HttpHeaders({
            "Content-Type": "application/json;charset=utf-8",
            "Authorization": "Bearer " + localStorage.getItem("scnntttoken")
        });
        return this.http.get(Config.apiUrl + uri, { headers, observe: 'response', responseType: 'arraybuffer' }).map(this._extractData);
    }
    ///////////////////////////////////////////////
    /*
    get(uri: string) {
      this.headers.delete("Authorization");
      this.headers.append("Authorization", "Bearer " + localStorage.getItem("scnntttoken"));
      return this._http.get(Config.apiUrl + uri, { headers: this.headers }).map(this.extractData);
    }
  
    post(uri: string, data?: any) {
      this.headers.delete("Authorization");
      this.headers.append("Authorization", "Bearer " + localStorage.getItem("scnntttoken"));
      return this._http.post(Config.apiUrl + uri, data, { headers: this.headers }).map(this.extractData);
    }
  
    put(uri: string, data?: any) {
      this.headers.delete("Authorization");
      this.headers.append("Authorization", "Bearer " + localStorage.getItem("scnntttoken"));
      return this._http.put(Config.apiUrl + uri, data, { headers: this.headers }).map(this.extractData);
    }
  
    delete(uri: string, key: string, id: string) {
      this.headers.delete("Authorization");
      this.headers.append("Authorization", "Bearer " + localStorage.getItem("scnntttoken"));
      return this._http.delete(Config.apiUrl + uri + "/?" + key + "=" + id, { headers: this.headers })
        .map(this.extractData);
    }
  
    deleteWithMultiParams(uri: string, params) {
      this.headers.delete('Authorization');
  
      this.headers.append("Authorization", "Bearer " + localStorage.getItem("scnntttoken"));
      var paramStr: string = '';
      for (let param in params) {
        paramStr += param + "=" + params[param] + '&';
      }
      return this._http.delete(Config.apiUrl + uri + "/?" + paramStr, { headers: this.headers })
        .map(this.extractData);
  
    }
  
    postFile(uri: string, data?: any) {
      let newHeader = new Headers();
      newHeader.append("Authorization", "Bearer " + localStorage.getItem("scnntttoken"));
      return this._http.post(Config.apiUrl + uri, data, { headers: newHeader })
        .map(this.extractData);
    }
    */

    private _extractData(res: HttpResponse<any>) {
        let body = res.body;
        return body || {};
    }

    // private extractData(res: Response) {
    //   let body = res.json();
    //   return body || {};
    // }

    public handleError(error: any) {
        if (error.status == 401) {
            localStorage.removeItem(`scnntttoken`);
            this._notificationService.printErrorMessage(`Bạn hết phiên đăng nhập. Mời đăng nhập lại.`);
            this._utilityService.navigateToLogin();
        }
        else if (error.status == 403) {
            localStorage.removeItem(`scnntttoken`);
            this._notificationService.printErrorMessage(`Bạn bị chặn truy cập`);
            this._utilityService.navigateToLogin();
        }
        else {
            this._notificationService.printErrorMessage('Đã có lỗi xảy ra');
        }
    }
}



// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/services/data.service.ts